import PropTypes from 'prop-types';
import React from 'react';
import { SvgIcon } from '@mui/material';
import { white } from '../../colors';

export default function Home(props) {
    const { fill = white, ...rest } = props;

    return (
        <SvgIcon fontSize="large" viewBox="0 0 24 24" {...rest}>
            <g transform="translate(2, 1.5)">
                <path
                    d="M10 13.6111C11.3807 13.6111 12.5 12.4685 12.5 11.059C12.5 9.64955 11.3807 8.50694 10 8.50694C8.61929 8.50694 7.5 9.64955 7.5 11.059C7.5 12.4685 8.61929 13.6111 10 13.6111Z"
                    stroke={fill}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
                <path
                    d="M2.5 8.98764C2.5 8.49904 2.5 8.25474 2.56169 8.02976C2.61633 7.83047 2.70614 7.64303 2.82669 7.47664C2.96278 7.28881 3.15168 7.13882 3.52949 6.83885L9.18141 2.35133C9.47418 2.11888 9.62057 2.00265 9.78221 1.95797C9.92484 1.91855 10.0752 1.91855 10.2178 1.95797C10.3794 2.00265 10.5258 2.11888 10.8186 2.35133L16.4705 6.83885C16.8483 7.13882 17.0372 7.28881 17.1733 7.47664C17.2939 7.64303 17.3837 7.83047 17.4383 8.02976C17.5 8.25474 17.5 8.49904 17.5 8.98764V15.1424C17.5 16.0952 17.5 16.5717 17.3183 16.9356C17.1586 17.2557 16.9036 17.516 16.59 17.6791C16.2335 17.8646 15.7668 17.8646 14.8333 17.8646H5.16667C4.23325 17.8646 3.76654 17.8646 3.41002 17.6791C3.09641 17.516 2.84144 17.2557 2.68166 16.9356C2.5 16.5717 2.5 16.0952 2.5 15.1424V8.98764Z"
                    stroke={fill}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill="none"
                />
            </g>
        </SvgIcon>
    );
}

Home.propTypes = {
    fill: PropTypes.string,
};
